import { css } from "@emotion/css";

import { grey } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

export const createLevelsNavStyles = ({
  spacing,
  borderRadius,
  typography,
}: Theme) => {
  return {
    root: css({
      display: "flex",
      backgroundColor: grey[100],
      borderRadius: borderRadius.navMenu,
      width: "100%",
      maxWidth: 400,
      margin: "0 auto",
    }),
    listElement: css({
      flexGrow: 1,
    }),
    navigationLink: css({
      padding: spacing([1.5, 0]),
      fontSize: typography.pxToRem(14),
      textAlign: "center",
      color: grey[500],
      borderRadius: borderRadius.navMenu,
      backgroundColor: "transparent",
      display: "block",
      textDecoration: "none",
      lineHeight: "normal",
    }),
    linkActive: css({
      fontWeight: typography.fontWeight.semiBold,
      color: grey[900],
      backgroundColor: grey[0],
    }),
  };
};
